module.exports = __webpack_public_path__ + "media/images/subheader-format-two-12f8a2319829c3207cf35d8b7a859a3c.png";